// -----------------------------------------------------------------------------
// Menu flutuante admin (`map-funnel-stage-and-add-ia-toggle`):
// lista usuários da org em modo autorun (aiAutoAttendEnabled=true) e
// permite pausar o modo de qualquer um individualmente.
//
// Visível apenas pra roles owner/admin/super_admin (filtragem feita pelo
// próprio Context — se user não é admin, `autorunUsers` é vazio).
// -----------------------------------------------------------------------------

import React, { useState } from 'react';
import { useAutorunUsers } from '../../context/UserPreferencesContext';
import { adminPatchUserPreferences } from '../../services/userPreferences';

export function AutorunAdminMenu() {
  const { users, reload } = useAutorunUsers();
  const [open, setOpen] = useState(false);
  const [busyFor, setBusyFor] = useState<string | null>(null);

  if (users.length === 0) return null;

  const handlePause = async (
    usuarioId: string,
    scope: 'new_only' | 'include_inflight'
  ) => {
    if (busyFor) return;
    setBusyFor(usuarioId);
    try {
      await adminPatchUserPreferences(usuarioId, {
        aiAutoAttendEnabled: false,
        scope,
      });
      await reload();
    } catch (err) {
      console.error('[AutorunAdminMenu] failed to pause user', usuarioId, err);
    } finally {
      setBusyFor(null);
    }
  };

  return (
    <div style={{ position: 'relative' }}>
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        title={`${users.length} usuário(s) em autorun — clique pra ver`}
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: 4,
          padding: '3px 8px',
          background: '#ecfdf5',
          border: '1px solid #a7f3d0',
          borderRadius: 14,
          fontSize: 11,
          color: '#059669',
          cursor: 'pointer',
        }}
      >
        <span style={{ fontWeight: 600 }}>{users.length}</span>
        <span>em autorun</span>
      </button>
      {open && (
        <>
          <div
            onClick={() => setOpen(false)}
            style={{
              position: 'fixed',
              inset: 0,
              zIndex: 998,
              background: 'transparent',
            }}
          />
          <div
            role="menu"
            style={{
              position: 'absolute',
              top: 'calc(100% + 6px)',
              right: 0,
              minWidth: 280,
              maxWidth: 360,
              maxHeight: 360,
              overflowY: 'auto',
              background: '#fff',
              border: '1px solid #e2e8f0',
              borderRadius: 8,
              boxShadow: '0 8px 24px rgba(15, 23, 42, 0.12)',
              zIndex: 999,
              padding: 6,
            }}
          >
            <div
              style={{
                padding: '6px 8px',
                fontSize: 11,
                fontWeight: 600,
                color: '#475569',
                textTransform: 'uppercase',
                letterSpacing: 0.5,
              }}
            >
              Usuários em autorun
            </div>
            {users.map((u) => (
              <div
                key={u.usuarioId}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  padding: '6px 8px',
                  borderTop: '1px solid #f1f5f9',
                  gap: 8,
                }}
              >
                <div style={{ minWidth: 0, flex: 1 }}>
                  <div style={{ fontSize: 13, color: '#0f172a', fontWeight: 500 }}>
                    {u.nome}
                  </div>
                  <div style={{ fontSize: 11, color: '#64748b' }}>{u.email}</div>
                </div>
                <div style={{ display: 'flex', gap: 4, flexShrink: 0 }}>
                  <button
                    type="button"
                    disabled={busyFor === u.usuarioId}
                    onClick={() => handlePause(u.usuarioId, 'new_only')}
                    title="Pausa novos leads; em curso continuam com IA"
                    style={{
                      padding: '3px 8px',
                      fontSize: 11,
                      border: '1px solid #cbd5e1',
                      background: '#fff',
                      borderRadius: 4,
                      cursor: busyFor === u.usuarioId ? 'wait' : 'pointer',
                    }}
                  >
                    Pausar novos
                  </button>
                  <button
                    type="button"
                    disabled={busyFor === u.usuarioId}
                    onClick={() => handlePause(u.usuarioId, 'include_inflight')}
                    title="Pausa novos E despromove leads em curso pra manual"
                    style={{
                      padding: '3px 8px',
                      fontSize: 11,
                      border: '1px solid #fca5a5',
                      background: '#fef2f2',
                      color: '#b91c1c',
                      borderRadius: 4,
                      cursor: busyFor === u.usuarioId ? 'wait' : 'pointer',
                    }}
                  >
                    Pausar tudo
                  </button>
                </div>
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
